// extracted by mini-css-extract-plugin
export default {"storyDetailListWrapper":"c-r_gm","storyDetailListWrapper__title":"c-r_gn","storyDetailListWrapper__timeline":"c-r_go","storyDetailListWrapper__list":"c-r_gp"};